// Helper Functions for Saga
import {select} from "../../../../shared/SagaService";
import {readListRequestWorker} from "../../../List/saga";
import {L} from "../../../List/reducer";
import {CustomFieldShow} from "../../../../enums/CustomFieldShow";

export function* copyCustomFields(transactionType, originType, transaction) {
    if (!transaction.fields)
        return null;

    // Fetch CUSTOM FIELDS if not fetch yet
    const fieldVersion = yield select(state => state.List.fieldVersion);
    if (fieldVersion === null) {
        yield readListRequestWorker({
            lists: [L.fields],
            counters: [],
            running: false,
            show_spinner: false,
        });
    }

    // Get Applicable Fields
    const fields = yield select(state => state.List.fields.transaction);
    const fieldKeywordOrigin = CustomFieldShow[originType];
    const fieldKeywordCurrent = CustomFieldShow[transactionType];
    // const applicableFieldIds = fields.filter(field => (
    //     field[fieldKeywordOrigin] &&
    //     field[fieldKeywordCurrent]).map(field => field.id),
    // );

    const applicableFieldIds = fields
        .filter(field => field[fieldKeywordOrigin] && field[fieldKeywordCurrent])
        .map(field => field.id);

    // Copy Field Data from Origin
    return transaction.fields
        .filter(field => applicableFieldIds.includes(field.field_id))
        .map(field => ({
            ...field,
            id: undefined,
        }));
}
